import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';
import { Component, Inject, Input, OnChanges, Output, SimpleChanges } from 'angular-ts-decorators';
import { IProductComparisonAttribute } from '../models/product-comparison-attribute';
import { ProductDifferencesToggleService } from '../services/product-differences.service';
import { OnVisibilityChange } from './models/on-visibility-change';

import template from './product-comparison-row.component.html';

@Component({
  selector: 'productComparisonRow',
  template,
})
export class ProductComparisonRowComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public readonly attribute?: IProductComparisonAttribute;
  @Input() public readonly productAttributes?: IAttribute[][];

  @Output() public readonly onVisibilityChange?: OnVisibilityChange;

  public cellValues: string[] = [];
  public isVisible = true;
  public haveDifferences = false;

  constructor(
    @Inject('productDifferencesToggleService') private readonly productDifferencesToggleService: ProductDifferencesToggleService,
  ) {}

  public ngOnChanges(changes: SimpleChanges<ProductComparisonRowComponent>) {
    if (changes.productAttributes && !changes.productAttributes.isFirstChange()) {
      this.cellValues = [];
    }
  }

  public onCellValueCalculated(cellValue?: string | null) {
    this.cellValues.push(cellValue);
    this.haveDifferences = !this.cellValues.every((val: string, i, arr: string[]) => val === arr[0]);
    this.isVisible = (this.attribute?.alwaysVisibleInComparison || this.cellValues.some((x: string) => (x && x !== 'false')));
    if (this.onVisibilityChange) {
      this.onVisibilityChange({ isVisible: this.isVisible });
    }
  }

  public get isHighlighted(): boolean {
    return this.haveDifferences && this.productDifferencesToggleService.isToggleOn;
  }
}
